import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommunicationLog } from '../../../entities/CommunicationLog';
import { Responsible } from '../../../entities/SalesPerson';
import { Task } from 'app/entities/Task';

declare var $: any;
@Component({
  selector: 'app-communication-log-view',
  templateUrl: './communication-log-view.component.html',
  styleUrls: ['./communication-log-view.component.css']
})
export class CommunicationLogViewComponent implements OnInit, AfterViewInit {

  public _communicationLogs: CommunicationLog[] = [];
  window = document.getElementById('communication-log-extension');

  inputFieldValue: string;
  isShowAllLogsForJob: boolean;
  isLoadingAllLogsForJob: boolean;
  communicationLogInput: string = "";
  chosenTask: Task;
  chosenProperty: string;
  textFieldValue: string;

  @Output()
  createCommunicationLogEmitter = new EventEmitter();
  @Output()
  setPendingCommunicationLogEmitter = new EventEmitter();
  @Output()
  showLogsForJobEmitter = new EventEmitter();

  @Input('CommunicationLogs')
  set CommunicationLogs(value: CommunicationLog[]) {
    if (value) {
      this._communicationLogs = [...value]
      this.resetInputField();
    }
  }

  @Input('salesPerson')
  set Salesperson(value: Responsible) {
    this._salesPerson = value;
  }

  @Input('InputField')
  set InputField(value: string) {
    this.inputFieldValue = value;
    this.isShowAllLogsForJob = false;
    this.isLoadingAllLogsForJob = false;
    this.resetInputField();
  }

  @Input('chosenTask')
  set ChosenTask(task: Task){
    if(task){
      Object.assign(this.chosenTask, task)
    }
  }

  _salesPerson: Responsible;

  constructor() {

  }

  ngAfterViewInit() {
    this.resetInputField();
  }

  resetInputField() {
    if (this.inputFieldValue === null || this.inputFieldValue === undefined) {
      this.communicationLogInput = '';
    } else {
      this.communicationLogInput = this.inputFieldValue;
    }
  }

  ngOnInit() {
    $(function () {
      $('[data-toggle="tooltip"]');
    });
  }

  createCommunicationLog() {
    if (this.communicationLogInput != '' && !!this.communicationLogInput) {
      //set pending communication log to undefined to make sure that 2 communication logs are not sent
      this.setPendingCommunicationLogEmitter.emit(undefined);
      this.createCommunicationLogEmitter.emit(this.communicationLogInput);
      this.communicationLogInput = '';
    }
  }

  setPendingCommunicationLog() {
    this.setPendingCommunicationLogEmitter.emit(this.communicationLogInput);
  }

  showTaskNumber(index: number): boolean {
    if (index === 0) {
      return true;
    } else return this._communicationLogs[index - 1].Task_No !== this._communicationLogs[index].Task_No;
  }
  
  showDateAndPreviousCreator(index: number): boolean {
    if (this.showCreatedByName(index) || this.showCreationDate(index) || this.showTaskNumber(index)) {
      return true;
    }
    return false;
  }

  showCreatedByName(index: number): boolean {
    if (index === 0) {
      return true;
    } else if (this.isCreatorSameAsPrevious(index)) {
      return false;
    } else {
      return true;
    }
  }

  isCreatorSameAsPrevious(index: number): boolean {
    if (this._communicationLogs[index - 1].Created_By_Ref === this._communicationLogs[index].Created_By_Ref) {
      return true;
    } else {
      return false;
    }
  }

  showCreationDate(index: number): boolean {
    if (index === 0) {
      return true;
    } else if (this.isDateSameAsPrevious(index)) {
      return false;
    } else {
      return true;
    }
  }

  private isDateSameAsPrevious(index: number): boolean {
    if (this.isDateSame(this._communicationLogs[index - 1].Creation_Date, this._communicationLogs[index].Creation_Date)) {
      return true;
    } else {
      return false;
    }
  }

  isDateSame(date1: Date, date2: Date): boolean {
    let _date1 = date1.toString().split('-');
    let _date2 = date2.toString().split('-');
    if (_date1.length > 1 && _date2.length > 1) {
      let _date1Split = _date1[2].split('T');
      let _date2Split = _date2[2].split('T');
      if (_date1[0] === _date2[0]) {
        if (_date1[1] === _date2[1]) {
          if (_date1Split[0] === _date2Split[0]) {
            return true;
          }
        }
      }
    }
    return false;

  }

  formatHyperLinksInComLog(note_text) {
    if (!!note_text){
      let text = note_text.replace(/(http.*?(\s|$))/, '<a target="_blank" href=\"$1\">$1</a>');
      return text;
    }
  }

  showOrHideLogsForEntireJob() {
    this._communicationLogs = [];
    this.isShowAllLogsForJob = !this.isShowAllLogsForJob;
    if (this.isShowAllLogsForJob) {
      this.isLoadingAllLogsForJob = true;
    }
    this.showLogsForJobEmitter.emit(this.isShowAllLogsForJob);
  }

  public openExpandedTextField(elementId: string) {
    setTimeout(() => {
      const inputField = document.getElementById(elementId);
      if(inputField){
        inputField.blur();
      }
      this.textFieldValue = this.communicationLogInput;
      $('#expandedTextFieldModalComm').modal('show');
    }, 5);
  }

  saveAndClose(value: string){
    this.communicationLogInput = value;
    this.closeExpandedTextField();
  }

  public closeExpandedTextField() {
    $('#expandedTextFieldModalComm').modal('hide');
  }
}




// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/communication-log/communication-log-view.component.ts